module.exports = __webpack_public_path__ + "static/media/selected_fishing_marker.2b0a7f85.svg";